// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import moment from 'moment';

import ContentBox from '../../ContentBox.jsx';
import Table from '../../Table.jsx';
import { Error } from '../../Typography.jsx';
import { Button, PrimaryButton } from '../../Buttons.jsx';

type Props = {
  wellChildChecks: Object[],
  activePatientId: string,
  dob: string,
  match: Object,
  print: boolean,
}

class SummaryPageComponent extends Component<Props> {
  // Create action column for each row
  actionsAccessor = (row: Object) => {
    const defaultButtons = (
      <div>
        <Link to={`${this.props.match.url}/${row.type}/${row._id}/view`}>
          <Button>View</Button>
        </Link>
        <Link to={`${this.props.match.url}/${row.type}/${row._id}/edit`}>
          <PrimaryButton>Edit</PrimaryButton>
        </Link>
      </div>
    );
    return defaultButtons;
  }

  render() {
    const intervalRegex = /\d+ (Month|Year)/;
    let wellChildChecks = this.props.wellChildChecks.map((wcc, index) => {
      const { age } = wcc;
      let dateDue;
      if (this.props.dob) {
        const dob = moment(this.props.dob);
        let ageInterval = (age.match(intervalRegex) || [''])[0];
        // 16-23 months due date should be 18 months (only exception)
        if (age === '16-23 Months') {
          ageInterval = '18 months';
        }
        const [amount, unit] = ageInterval.split(' ');
        dateDue = dob.add(amount, unit).toISOString();
      }

      return {
        age,
        type: index,
        dateDue,
        ...wcc,
      };
    });

    if (this.props.print) {
      const now = moment().toISOString();
      wellChildChecks = wellChildChecks.filter(wcc => wcc.dateDue < now);
    }

    const columns = [
      {
        Header: 'Age',
        id: 'age',
        accessor: 'age',
      },
      {
        Header: 'Date Due',
        id: 'dateDue',
        cell: item => (item.dateDue ? moment(item.dateDue).format() : '--'),
      },
      {
        Header: 'Date Completed',
        id: 'date',
        cell: (item) => {
          if (item.overridden) {
            return '(overridden)';
          }
          // overdue if no administered date and if due date earlier than now
          const overdue = !item.date && item.dateDue && moment(item.dateDue) < moment();
          return overdue ? <Error>-- (overdue)</Error>
            : item.date ? moment(item.date).format() : '--';
        },
      },
      {
        Header: 'Development',
        id: 'development',
        cell: (item) => {
          const milestones = item.developmentMilestones;
          let milestoneFrac = '--';
          const devResult = item.developmentNormal === false ? 'Delayed'
            : item.developmentNormal ? 'Normal' : '--';
          if (milestones.length) {
            const numChecked = milestones.filter(v => v).length;
            milestoneFrac = `${numChecked}/${milestones.length}`;
          }
          if ((devResult === '--' && milestoneFrac === '--') || item.overridden) {
            return '--';
          }
          return `${devResult} (${milestoneFrac})`;
        },
      },
    ];

    return (
      <ContentBox title="Summary">
        <Table
          columns={columns}
          data={wellChildChecks}
          style={{}} // override max height on default Table
          extraActions={this.actionsAccessor}
        />
      </ContentBox>
    );
  }
}

const mapStateToProps = state => ({
  wellChildChecks: state.patient.data.wellChildChecks,
  activePatientId: state.patient.data.activePatientId,
  dob: state.patient.data.generalInfo.dob,
  print: state.patient.print,
});

const SummaryPage = connect(
  mapStateToProps,
)(SummaryPageComponent);

export default SummaryPage;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/wellChildCheck/SummaryPage.jsx